export enum LogisticsPlanAudience {    
    Nkr = 1,
    CourierVendor = 2
}